export default __webpack_public_path__ + "static/media/Armbands of Insanity.96a74474.jpg";